(() => {
	const content = document.querySelector('.single .entry-content');
  const iframes = document.querySelectorAll('.entry-content iframe');

	if (!content) {
		return;
	}

	/**
	 * Helper function to get ratio of 2 numbers
	 * @param {int} num_1
	 * @param {int} num_2
	 * @returns ratio
	 */
	const getRatio = (num_1, num_2) => {
		for (num=num_2; num>1; num--) {
			if ((num_1 % num) == 0 && (num_2 % num) == 0) {
				num_1=num_1/num;
				num_2=num_2/num;
			}
		}
		const ratio = [num_1,num_2];
		return ratio;
	}

	/**
	 * If iframe src is youtube or vimeo, adjust dimensions based on ratio.
	 */
	iframes.forEach(iframe => {
		if (
			iframe.src.includes('youtube') ||
			iframe.src.includes('vimeo')
		) {
			const frameWidth = iframe.offsetWidth;
			const frameHeight = iframe.offsetHeight;
			const ratio = getRatio(frameWidth, frameHeight);
			const contentWidth = content.offsetWidth;
			const ratioW = contentWidth / ratio[0];
			const calculatedHeight = ratioW * ratio[1];
			iframe.width = contentWidth;
			iframe.height = calculatedHeight;
		}
	});
})();
